import React, { useState, useEffect, useContext } from "react";
import { api } from "../../api";
import Ctx from "../../contexts/AppContext";
import { crd, bdg, sp, rad, type, icBox, listRow } from "../../constants/styles";
import Ic from "../common/Ic";

export default function AdminProperties() {
  const { h, go } = useContext(Ctx);
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      const params = {};
      if (search) params.search = search;
      if (filter !== "all") params.type = filter;
      const res = await api.adminGetProperties(params);
      if (res.success) setItems(res.properties || []);
      setLoading(false);
    };
    const timer = setTimeout(load, search ? 400 : 0);
    return () => clearTimeout(timer);
  }, [search, filter]);

  const filters = ["all", "residential", "commercial"];
  const tabS = (active) => ({
    padding: `${sp.xs}px ${sp.md}px`, borderRadius: rad.pill, border: "none",
    background: active ? h.ac : "transparent", color: active ? "#fff" : h.ts,
    fontSize: 11, fontWeight: active ? 600 : 400, cursor: "pointer",
  });

  return <div style={{ paddingTop: sp.lg }} className="animate-fadeIn">
    <button onClick={() => go("dash")} style={{ background: "none", border: "none", color: h.ac, cursor: "pointer", ...type.sm, marginBottom: sp.md, display: "flex", alignItems: "center", gap: sp.xs }}>
      <Ic n="arrow-left" s={14} c={h.ac} /> Dashboard
    </button>

    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: sp.lg }}>
      <h2 style={{ ...type.h2, color: h.tx, margin: 0 }}>All Properties</h2>
      <span style={{ ...type.xs, color: h.ts }}>{items.length} found</span>
    </div>

    {/* Search */}
    <div style={{ position: "relative", marginBottom: sp.md }}>
      <Ic n="search" s={16} c={h.tt} />
      <input value={search} onChange={e => setSearch(e.target.value)}
        placeholder="Search name or address..."
        style={{ width: "100%", padding: `${sp.sm}px ${sp.md}px`, paddingLeft: 36, borderRadius: rad.md, border: `1px solid ${h.bd}`, background: h.ib, color: h.tx, ...type.sm, outline: "none", boxSizing: "border-box" }}
      />
    </div>

    {/* Filters */}
    <div style={{ display: "flex", gap: sp.xs, marginBottom: sp.lg }}>
      {filters.map(f => <button key={f} onClick={() => setFilter(f)} style={tabS(filter === f)}>
        {f === "all" ? "All" : f.charAt(0).toUpperCase() + f.slice(1)}
      </button>)}
    </div>

    {loading ? (
      <div style={{ textAlign: "center", padding: sp.xxxl }}>
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke={h.ac} strokeWidth="2" style={{ animation: "spin 1s linear infinite" }}><path d="M21 12a9 9 0 11-6.219-8.56" /></svg>
      </div>
    ) : items.length === 0 ? (
      <div style={{ ...crd(h), textAlign: "center", padding: sp.xxxl }}>
        <Ic n="home" s={28} c={h.tt} />
        <div style={{ ...type.sm, color: h.tt, marginTop: sp.sm }}>No properties found</div>
      </div>
    ) : (
      <div style={{ ...crd(h), padding: 0, overflow: "hidden" }}>
        {items.map((p, i) => (
          <div key={p.id} style={listRow(h, i === items.length - 1)}>
            <div style={{ display: "flex", alignItems: "center", gap: sp.md, flex: 1, minWidth: 0 }}>
              <div style={icBox(h.gn, 36)}>
                <Ic n="home" s={16} c={h.gn} />
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <div style={{ ...type.sm, color: h.tx, fontWeight: 600, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>{p.name}</div>
                <div style={{ ...type.xs, color: h.tt, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                  {p.org_name || "—"} {"\u00B7"} {p.address || "No address"}
                </div>
              </div>
            </div>
            <div style={{ textAlign: "right", flexShrink: 0, marginLeft: sp.sm }}>
              <span style={bdg(p.type === "commercial" ? `${h.pp}20` : `${h.ac}20`, p.type === "commercial" ? h.pp : h.ac)}>
                {p.type || "residential"}
              </span>
              {p.rent && <div style={{ ...type.xs, color: h.gn, marginTop: sp.xs }}>{"\u20B9"}{p.rent}</div>}
            </div>
          </div>
        ))}
      </div>
    )}
  </div>;
}
